import variables from '../variables';

const primary = {
    main: variables.themeColors.primary,
};

export default primary;
